import Qs from 'qs';
import config from '@/config/index';

const exportFile = (path, params) => {
  const query = Qs.stringify(params);
  window.open(`${config.host}${path}?${query}`, 'target');
};

export default exportFile;
